module.exports = __webpack_public_path__ + "img/img-apart-meio.b718d84d.png";